import axios from "@/index";
import { set } from "lodash";
const generatedCode = {
  state: {
    data: "",
    msg: ""
  },
  getters: {},
  actions: {
    getCheckCode: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setCheckCode",
                (state, { data: response.data, msg: response.msg })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setCheckCode(state, action) {
      state.data = action.data;
      state.msg = action.msg;
    }
  }
};
export default generatedCode;
